<template>
  <div class="season">
    <loading-state :state="state"></loading-state>
    <div v-if="season">
      <h2>{{season.name}}</h2>
      <cricket-season-menu :showSeason="true" :isMetric="isMetric" :seasonKey="season.key"></cricket-season-menu>
      <section>
        <dl class="dl-tableview">
          <dt>Card Name</dt>
          <dd>{{season.card_name}}</dd>
          <dt>Date</dt>
          <dd>{{season.startDate | relativeShortDate}}<span v-if="season.endDate"> - {{season.endDate | relativeShortDate}}</span></dd>
          <dt>Venue</dt>
          <dd>{{season.venue}}</dd>
        </dl>
      </section>

      <div>
        <h2>Matches</h2>
        <div class="filterable-content">
          <div class="left-part width300">
            <div class="group">
              <h5 class="silent">Filter Matches</h5>
              <ul>
                <li
                  :class="{active:(activeFilter === null &&  selectedMatchDay === null)}"
                  class="clickable box"
                  @click="filterCommon(null)">All</li>
                <li
                  :class="{active:activeFilter === 'upcoming'}"
                  class="clickable box"
                  @click="filterCommon('upcoming')">Upcoming</li>
                <li
                  :class="{active:activeFilter === 'completed'}"
                  class="clickable box"
                  @click="filterCommon('completed')">Completed & Live</li>

              </ul>
            </div>
            <div
              class="group"
              v-for="roundKey in season.rounds_info" :key="roundKey">
              <h5 class="silent">{{season.rounds[roundKey].name}}</h5>
              <ul>
                <li
                  v-for="groupKey in season.rounds[roundKey].groupKeys"
                  :key="groupKey"
                  :class="{active:activeFilter === groupKey}"
                  class="clickable box"
                  @click="filterGroup(groupKey)">{{season.rounds[roundKey].groups[groupKey].name}}
                    <small>
                      ({{season.rounds[roundKey].groups[groupKey].matches.length}} matches)
                    </small>
                </li>
              </ul>
            </div>
            <div class="group" v-if="season.teamKeys.length > 2">
              <h5 class="silent">Teams</h5>
              <ul>
                <li
                  v-for="teamKey in season.teamKeys"
                  :key="teamKey"
                  :class="{active:activeFilter === teamKey}"
                  class="clickable box"
                  @click="filterTeam(teamKey)">{{season.teams[teamKey].card_name}}</li>
              </ul>
            </div>
            <div class="group">
              <h5 class="silent">Days</h5>
              <ul>
                <li
                  v-for="(day, i) in season.matchDays"
                  :key="i"
                  :class="{
                    'silent': !selectedMatchDay && !haveMatchForDay(day),
                    'active': selectedMatchDay && selectedMatchDay.isSame(day, 'days')}"
                  class="clickable tag"
                  @click="filterMatchDay(day)">
                    <span v-if="day.date() == 1">{{day | momentFormat('MMM DD')}}</span>
                    <span v-else>{{day | momentFormat('DD')}}</span>
                  </li>
              </ul>
            </div>
          </div>
          <div class="right-part">
            <section>
              <div class="sub-content">
                <div v-if="activeFilterGroup === 'group'">
                  <!-- <h2>Teams</h2> -->
                  <div  class="item compact">
                    <span class="tag" v-for="(teamKey, i) in teamsOfGroup(activeFilter)" :key="i">
                      <span v-if="season.teams[teamKey]">
                        <router-link
                          class="clean"
                          :to="{ name: isMetric ? 'MetricSeasonTeam' : 'cricketSeasonTeam', params:{key:season.key, teamkey:teamKey}}">{{season.teams[teamKey].card_name}}</router-link>
                      </span>
                      <span v-else>{{teamKey}}</span>
                    </span>
                  </div>
                  <div v-if="isMetric">
                    <span v-for="matchKey in matchesOfGroup(activeFilter)"
                      :key="matchKey">
                        <cricket-match-mini 
                        class="item compact link"
                        :matchKey="matchKey"
                        :isMetric="isMetric"
                        :showDate="true"
                        :showSport="false"
                        :useShortTitle="true"
                        :showSeason="false"></cricket-match-mini>
                    </span>
                  </div>
                </div>
                <div v-if="matchKeyslist && matchKeyslist.length > 0 && isMetric">
                  <div v-for="(matchKeys, index) in matchKeyslist" :key="index">
                    <div v-for="matchkey in matchKeys" :key="matchkey">
                      <cricket-match-mini 
                        class="item compact link"
                        :matchKey="matchkey" 
                        :isMetric="isMetric"
                        :showDate="true"
                        :showSport="false"
                        :useShortTitle="true"
                        :showSeason="false"></cricket-match-mini>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- <h2>Matches</h2> -->
                  <cricket-match-mini 
                    class="item compact link"
                    v-for="matchKey in season.matchKeys"
                    v-if="shouldShowMatch(matchKey)"
                    :key="matchKey"
                    :match="season.matches[matchKey]" 
                    :showDate="true"
                    :showSport="false"
                    :useShortTitle="true"
                    :showSeason="false"></cricket-match-mini>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <section>
        <h2>Teams</h2>
        <div class="sub-content">
          <div class="item compact link" v-for="teamKey in season.teamKeys" :key="teamKey">
            <div>
              <router-link
              class="clean"
              :to="{name: isMetric ? 'MetricSeasonTeam' : 'cricketSeasonTeam', params:{key:season.key, teamkey:teamKey}}">
              {{season.teams[teamKey].name}} ({{season.teams[teamKey].card_name}})</router-link>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
import { CricketSeason } from '@/models/cricket/season'
import { DataState, AppState } from '@/state'
import Utils from '@/utils'
import { CricketMatch } from '@/models/cricket/match'
import moment from 'moment'

export default {
  name: 'season',
  props: {
    isMetric: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      seasonKey: this.$route.params.key,
      season: null,
      activeFilter: null,
      activeFilterGroup: null,
      selectedMatchDay: null,
      state: DataState.newLoading(),
      matchKeyslist: []
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.seasonKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`cricket_season_${this.seasonKey}`)
      AppState.updateTitles(newTitle, newTitle)

      CricketSeason.fetch(this.seasonKey, this.isMetric).then(season => {
        const newTitle = season.name
        AppState.updateTitles(newTitle, newTitle)
        this.season = season
        this.state.changeToLoaded()
        this.getAllMacthes()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.season = null
      this.activeFilter = null
      this.selectedMatchDay = null
    },
    refreshView () {

    },

    filterCommon (filterKey) {
      this.activeFilter = filterKey
      this.activeFilterGroup = 'common'
      this.selectedMatchDay = null
    },

    filterGroup (groupKey) {
      this.activeFilter = groupKey
      this.activeFilterGroup = 'group'
      this.selectedMatchDay = null
    },

    filterTeam (teamKey) {
      this.activeFilter = teamKey
      this.activeFilterGroup = 'team'
      this.selectedMatchDay = null
    },

    filterMatchDay (day) {
      this.activeFilter = null
      this.activeFilterGroup = null
      this.selectedMatchDay = day
    },

    teamsOfGroup(groupKey) {
      const group = this.getGroup(groupKey)
      if (group) {
        return group.teams
      }
    },

    matchesOfGroup (groupKey) {
      const group = this.getGroup(groupKey)
      if (group) {
        return group.matches
      }
    },

    getAllMacthes () {
      for (let roundKey of this.season.rounds_info) {
        const groups = this.season.rounds[roundKey].groupKeys
        for (let groupKey of groups) {
          this.matchKeyslist.push(this.matchesOfGroup(groupKey))
        }
      }
    },

    getGroup (groupKey) {
      for (let i = 0; i < this.season.rounds_info.length; i++) {
        const roundKey = this.season.rounds_info[i]
        const group = this.season.rounds[roundKey].groups[groupKey]
        if (group) {
          return group
        }
      }

      return null
    },

    haveMatchForDay (day) {
      for (let i = 0; i < this.season.matchKeys.length; i++) {
        const match = this.season.matches[this.season.matchKeys[i]]
        if (match.start_at.isSame(day, 'days')) {
          return true
        }
      }

      return false
    },

    shouldShowMatch (matchKey) {
      const match = this.season.matches[matchKey]

      if (this.selectedMatchDay != null) {
        return this.selectedMatchDay.isSame(match.start_at, 'days')
      }

      if (this.activeFilterGroup === 'common') {
        if (this.activeFilter === null) {
          return true
        } else if (this.activeFilter === 'upcoming') {
          const now = new Date()
          return match.start_at.isAfter(now)
        } else if (this.activeFilter === 'completed') {
          const now = new Date()
          return match.start_at.isBefore(now)
        }

        return false
      } else if (this.activeFilterGroup === 'group') {
        const group = this.getGroup(this.activeFilter)
        if (group && group.matches.indexOf(matchKey) > -1) {
          return true
        }

        return false
      } else if (this.activeFilterGroup === 'team') {
        const teamKey = this.activeFilter
        if (match.teams.a.match.season_team_key === teamKey || match.teams.b.match.season_team_key === teamKey) {
          return true
        }
        return false
      }

      return (this.activeFilter === null && this.selectedMatchDay === null)
    }

  }
}
</script>
